export const CTA_URL = "https://t.me/RaidRTM?text=Halo%2C%20saya%20mau%20tahu%20lebih%20lanjut%20tentang%20rebate%20%2415%20per%20lot.";

export const NAV_LINKS = [
  { label: "Keuntungan", id: "keuntungan" },
  { label: "Koleksi Hadiah", id: "hadiah" },
  { label: "Cara Bergabung", id: "cara-bergabung" },
];

export const GIFTS = [
  { id: "mobil", name: "Mobil Mercedes-Benz", category: "Lifestyle", lots: "80.000", img: "/images/mobil-mercedes.jpg", alt: "Hadiah mobil Mercedes-Benz untuk akun BOOSTER" },
  { id: "ninja-250", name: "Kawasaki Ninja 250 cc", category: "Motor", lots: "11.700", img: "/images/ninja-250.jpg", alt: "Hadiah Kawasaki Ninja 250 cc untuk akun BOOSTER" },
  { id: "tokyo", name: "Liburan ke Tokyo", category: "Lifestyle", lots: "11.111", img: "/images/tokyo.jpg", alt: "Hadiah liburan ke Tokyo untuk akun BOOSTER" },
  { id: "iphone-duo", name: "iPhone Duo", category: "Gadget", lots: "8.300", img: "/images/iphone-duo.jpg", alt: "Hadiah iPhone Duo — dua iPhone untuk akun BOOSTER" },
  { id: "macbook", name: "MacBook", category: "Gadget", lots: "5.800", img: "/images/macbook.jpg", alt: "Hadiah MacBook untuk akun BOOSTER" },
  { id: "vario-160", name: "Honda Vario 160 cc", category: "Motor", lots: "4.500", img: "/images/vario-160.jpg", alt: "Hadiah Honda Vario 160 cc untuk akun BOOSTER" },
  { id: "vario-125", name: "Honda Vario 125 cc", category: "Motor", lots: "3.400", img: "/images/vario-125.jpg", alt: "Hadiah Honda Vario 125 cc untuk akun BOOSTER" },
  { id: "iphone-18", name: "iPhone 18 Pro Max", category: "Gadget", lots: "1.400", img: "/images/iphone-18.jpg", alt: "Hadiah iPhone 18 Pro Max untuk akun BOOSTER" },
  { id: "ipad", name: "iPad", category: "Gadget", lots: "1.250", img: "/images/ipad.jpg", alt: "Hadiah iPad untuk akun BOOSTER" },
  { id: "apple-watch", name: "Apple Watch", category: "Gadget", lots: "1.250", img: "/images/apple-watch.jpg", alt: "Hadiah Apple Watch untuk akun BOOSTER" },
  { id: "airpods", name: "AirPods", category: "Gadget", lots: "500", img: "/images/airpods.jpg", alt: "Hadiah AirPods untuk akun BOOSTER" },
];

export const FILTERS = ["Semua Hadiah", "Gadget", "Motor", "Lifestyle"];

export const STEPS = [
  { num: "01", text: "Trading dengan akun BOOSTER" },
  { num: "02", text: "Rebate USD 15 per lot" },
  { num: "03", text: "Jelajahi milestone hadiah" },
];
